/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Sugg_EditInputs */

const cs_addr_sugg_edit = /** @type {(inputs: Addr_Sugg_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit`)
};

const en_addr_sugg_edit = /** @type {(inputs: Addr_Sugg_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Addr_Sugg_EditInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_edit = /** @type {((inputs?: Addr_Sugg_EditInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_EditInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_edit(inputs)
	return cs_addr_sugg_edit(inputs)
});